export const SIGN_IN_CARDS_PDF_FILENAME = 'sign-in-cards.pdf';
